import React from "react"
import FormControl from "@mui/material/FormControl"
import * as moment from "moment"
import { TextField, Typography } from "@mui/material"
import * as UIConstants from "./UIConstants"

export default function CreatedDate(props) {
  const { name, label, value, onChange, helperText } = props

  const helperTextId = name + "_helper_text"

  return (
    <FormControl style={{ margin: 0, padding: 0 }}>
      <TextField
        name={name}
        id={name}
        value={moment(value.toDate()).format("D-MMM-yyyy hh:mm a")}
        disabled={true}
        onChange={onChange}
        label={label}
        variant={UIConstants.STANDARD_INPUT_VARIANT}
        size={UIConstants.STANDARD_INPUT_SIZE}
        aria-describedby={helperTextId}
        helperText={
          <Typography variant="caption" component={"span"}>
            {helperText}
          </Typography>
        }
      />
    </FormControl>
  )
}
